import { useState } from 'react'

import { PrototypeFrame } from '../../PrototypeFrame'
import { ARTIFACTS_LABEL } from './accountModel'
import { AGENT_FACES, DEFAULT_FACE } from './agentFaces'
import { AgentNameProvider } from './agentName'
import { AGENT_NAME, MVP_TAB_DETAIL, MVP_TAB_LABELS, MVP_TAB_PAGES, MVP_TABS } from './caiMvp'
import { ProductOnboardingDesktop } from './ProductOnboardingDesktop'
import { ProfileMenu } from './ProfileMenu'
import { ProductTab } from './prototypeNav'
import { TrialNotice } from './TrialNotice'

/**
 * Two accounts, not two prototypes: the same screens with a different set of
 * products bought. Switching between them is demo scaffolding, which is why it
 * lives under its own heading in the profile menu rather than anywhere a
 * customer would look.
 */
const VERSIONS = [
  { name: 'Cai only', active: [] as ProductTab[] },
  { name: 'Insurance + Bookkeeping', active: [ProductTab.INSURANCE, ProductTab.BOOKKEEPER] },
]

/**
 * The MVP account at the size it would actually be used, rather than drawn at
 * 1100x620 beside its alternatives. Nothing about the account changes — only
 * the room it has.
 */
export function CaiMvpFullPage() {
  const [version, setVersion] = useState(VERSIONS[0].name)
  const active = VERSIONS.find((entry) => entry.name === version)?.active ?? []
  return (
    <PrototypeFrame title="Cai MVP" hideBanner>
      <AgentNameProvider
        name={AGENT_NAME}
        face={DEFAULT_FACE}
        faceOptions={AGENT_FACES}
        artifactsLabel={ARTIFACTS_LABEL}
      >
        <ProductOnboardingDesktop
          // A viewport of its own, and no border: the account is the page.
          className="h-svh border-0"
          tabs={MVP_TABS}
          tabLabels={MVP_TAB_LABELS}
          tabDetail={MVP_TAB_DETAIL}
          tabPages={MVP_TAB_PAGES}
          activeTabs={active}
          profile={
            <ProfileMenu
              versions={VERSIONS.map(({ name }) => ({ name, active: [] }))}
              current={version}
              onChoose={setVersion}
            />
          }
          composerFooter={<TrialNotice />}
          softComposer
          chromeTint
          handoff
        />
      </AgentNameProvider>
    </PrototypeFrame>
  )
}
